
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class LanguageSwitch extends Vue {
  @Prop({ required: true }) currentLocale!: string;
  @Prop({ required: true }) locales!: string[];
  @Prop({ required: true }) primaryColor!: string;
  @Prop({ default: false }) isDark!: boolean;
  @Prop({ default: false }) isPrimaryBorder!: boolean;

  get classNames() {
    return {
      'languages--dark': this.isDark,
    };
  }

  get style() {
    return {
      borderColor: this.isPrimaryBorder ? this.primaryColor : '',
    };
  }

  get arrowColor(): string {
    if (this.isPrimaryBorder) {
      return this.primaryColor;
    }

    return this.isDark ? '#fff' : '#000';
  }
}
